import {FormInputProps} from "_types/form";
import {Form} from 'react-bootstrap';
import {get} from "react-hook-form";

export const CheckInput = ({
    type,
    label,
    name,
    placeholder,
    register,
    errors,
    comp,
    rows,
    className,
    refCallback,
    ...otherProps
}: FormInputProps) => {
    const fieldErrors = get(errors, name);
    return (
        <>
            <Form.Check
                type={type}
                label={label}
                name={name}
                id={name}
                ref={(r: HTMLInputElement) => {
                    if (refCallback) refCallback(r);
                }}
                className={className}
                isInvalid={fieldErrors}
                {...(register ? register(name) : {})}
                {...otherProps}
            />

            {fieldErrors ? (
                <Form.Control.Feedback type="invalid" className="d-block">
                    {fieldErrors['message'] as any}
                </Form.Control.Feedback>
            ) : null}
        </>
    );
};
